module.exports = __webpack_public_path__ + "img/AM_BM_PM@3x.b26d5ecd.png";